import { forwardRef, useId, useImperativeHandle, useRef } from "react";
import { closeDialog, showDialog } from "../ui/dialog";
import { ChatIcon } from "../ui/icons/Icon";
import styles from "./ManualCopyDialog.module.css";

export type ManualCopyHandle = { show: () => void };

/** Copia manual cuando el navegador no deja copiar (ManualCopyDialog.razor): mismo HTML y mismo comportamiento. */
export const ManualCopyDialog = forwardRef<
  ManualCopyHandle,
  { labels: Record<string, string>; content: string | null }
>(function ManualCopyDialog({ labels, content }, ref) {
  const dialog = useRef<HTMLDialogElement>(null);
  const text = useRef<HTMLTextAreaElement>(null);
  const titleId = "e2-copy-" + useId().replace(/[^a-z0-9]/gi, "");
  const L = (key: string) => labels[`E1_${key}`] ?? `[E1_${key}]`;
  const back = labels["C1_BACK"] ?? L("CLOSE");
  const s = styles.scope;
  useImperativeHandle(ref, () => ({ show: () => showDialog(dialog.current) }));
  const close = () => closeDialog(dialog.current);
  const selectAll = () => {
    const element = text.current;
    element?.focus();
    element?.select();
    element?.setSelectionRange(0, element.value.length);
  };
  return (
    <dialog className={`e2-copy-dialog ${s}`} ref={dialog} aria-labelledby={titleId}>
      <div className={`e2-copy-head ${s}`}>
        <button type="button" className={`button ghost e2-copy-back ${s}`} aria-label={back} onClick={close}>
          <ChatIcon name="arrow-left" />
        </button>
        <h2 className={s} id={titleId}>
          {L("EXCEL")}
        </h2>
        <button type="button" className={`button ghost e2-copy-close ${s}`} aria-label={L("CLOSE")} onClick={close}>
          <ChatIcon name="x" />
        </button>
      </div>
      <p className={s}>{L("MANUAL_COPY_HELP")}</p>
      <textarea className={s} ref={text} readOnly aria-label={L("EXCEL")} value={content ?? ""}></textarea>
      <div className={`actions ${s}`}>
        <button type="button" className={`button ghost e2-copy-select ${s}`} disabled={!content} onClick={selectAll}>
          {L("SELECT_ALL")}
        </button>
        <button type="button" className={`button e2-copy-done ${s}`} onClick={close}>
          {L("DONE")}
        </button>
      </div>
    </dialog>
  );
});
